module.exports = __webpack_public_path__ + "static/media/bg-heart-risk.71b6a37e.png";